import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ModulesActions from 'store/ducks/modules';
import { MODULES, saveCurrentModuleToStorage } from 'config/modules';
import { usePermissions } from 'hooks/usePermissions';
import {
  Container,
  ModuleItem,
  ModuleIcon,
  ModuleName,
  ModuleDescription,
  CurrentModuleBadge,
} from './styles';

export default function ModuleSelector({ anchorEl, open, onClose }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentModule } = useSelector((state) => state.modules);
  const { hasModuleAccess, loading: permissionsLoading } = usePermissions();

  // Filtrar módulos baseado em permissões
  const availableModules = React.useMemo(() => {
    // Se ainda está carregando permissões, mostrar todos os módulos temporariamente
    if (permissionsLoading) {
      return Object.values(MODULES);
    }
    
    return Object.values(MODULES).filter((module) => {
      return hasModuleAccess(module.id);
    });
  }, [hasModuleAccess, permissionsLoading]);

  const handleSelectModule = (module) => {
    // Não fazer nada se o módulo selecionado for o mesmo que o atual
    if (currentModule?.id === module.id) {
      onClose();
      return;
    }

    dispatch(ModulesActions.setModuleRequest(module.id));
    saveCurrentModuleToStorage(module.id);
    dispatch(ModulesActions.setModuleSuccess(module));
    
    // Encontrar o menu Dashboard do módulo selecionado e redirecionar
    const dashboardMenu = module.menus?.find(menu => 
      menu.label.toLowerCase() === 'dashboard'
    );
    
    if (dashboardMenu) {
      history.push(dashboardMenu.path);
    }
    
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          minWidth: '280px',
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Container>
        <List>
          {availableModules.map((module) => {
            const IconComponent = module.icon;
            const isSelected = currentModule?.id === module.id;
            
            return (
              <ModuleItem
                key={module.id}
                onClick={() => handleSelectModule(module)}
                selected={isSelected}
              >
                <ListItemIcon>
                  <ModuleIcon color={module.color}>
                    <IconComponent size={24} />
                  </ModuleIcon>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <ModuleName>{module.name}</ModuleName>
                      {isSelected && <CurrentModuleBadge>Atual</CurrentModuleBadge>}
                    </div>
                  }
                />
              </ModuleItem>
            );
          })}
        </List>
      </Container>
    </Popover>
  );
}

